import { createContext, useContext } from "react";

/** The new notifications panel's tabs (plan 2D F9): "To approve" and "Updates". */
export type InboxTab = "approve" | "updates";
/** No tab: "To approve" when something waits there, else "Updates". */
export type OpenInbox = (tab?: InboxTab) => void;

const Ctx = createContext<OpenInbox | null>(null);

/**
 * Opens the new notifications panel on a tab. The new frame (shell/NextFrame) provides it and mounts the panel;
 * outside it there is no opener, and callers leave their button out. Never today's panel (owner answer 8).
 */
export const InboxOpenerProvider = Ctx.Provider;

/** The new panel's opener, or null where it is not mounted. */
export const useOpenInbox = (): OpenInbox | null => useContext(Ctx);
